import warningIcon from "../../../assets/icons/warning.svg";

interface IPaymentFailedPage {
  currency: string;
  amount: number;
}

export const PaymentFailedPage = (props: IPaymentFailedPage) => {
  return (
    <div className="payment-failed--container flex-container justify-content--center align-items--center">
      <div className="flex-container col justify-content--center align-items--center">
        <div className="payment-completed-icon--container">
          <img
            src={warningIcon}
            alt="error"
            className="payment-completed--icon"
          />
        </div>

        <div className="flex-container col align-items--center">
          <h4 className="step-title font-ctm--bold">Payment Failed</h4>

          <p>
            <span className="feedback-request--description">
              Your payment could not be completed.
            </span>
          </p>

          <p className="switchapp-small">
            <span className="feedback-request--description">
              Please contact the merchant or reload the page.
            </span>
          </p>
        </div>

        {/* <div className="payment-amount--container flex-box flex-container">
          <div className="flex-container">
            <strong>
              {props.currency} {props.amount}
            </strong>
          </div>
        </div> */}
      </div>
    </div>
  );
};
